import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule, MatButtonModule, MatButtonToggleModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDividerModule, MatIconModule, MatInputModule, MatPaginatorModule, MatRadioModule, MatSelectModule, MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTooltipModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxBarcodeModule } from 'ngx-barcode';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DirectiveModule } from '../../model/module/directive.module';
import { PipeModule } from '../../model/module/pipe.module';
import { ComponentModule } from '../../ui/component/component.module';
import { PartialsModule } from '../partials/partials.module';
import { AlertComponent } from './alert/alert.component';
import { BarcodeComponent } from './barcode/barcode.component';
import { CampaignSelectorComponent } from './campaign-selector/campaign-selector.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { DialogAnnulment } from './dialog-annulment/dialog-annulment.component';
import { AuthNoticeComponent } from './dialog-calendar/auth-notice/auth-notice.component';
import { DialogCampaignProductComponent } from './dialog-campaign-product/dialog-campaign-product.component';
import { DialogCampaignComponent } from './dialog-campaign/dialog-campaign.component';
import { DialogCommercialStructureComponent } from './dialog-commercial-structure/dialog-commercial-structure.component';
import { DialogConfigBrandingComponent } from './dialog-config-branding/dialog-config-branding.component';
import { DialogConfigBrochureComponent } from './dialog-config-brochure/dialog-config-brochure.component';
import { DialogConfigDebtComponent } from './dialog-config-debt/dialog-config-debt.component';
import { DialogConfigLogisticComponent } from './dialog-config-logistic/dialog-config-logistic.component';
import { DialogCreditNotesComponent } from "./dialog-credit-notes/dialog-credit-notes.component";
import { DialogDebtReportComponent } from './dialog-debt-report/dialog-debt-report.component';
import { DialogMessageComponent } from './dialog-message/dialog-message.component';
import { DialogCopyActionPointComponent } from './club-gigot/dialog-copy-action-point-configuration/dialog-copy-action-point.component';
import { DialogOrderBillingComponent } from './dialog-order-billing/dialog-order-billing.component';
import { DialogOrderEventComponent } from './dialog-order-event/dialog-order-event.component';
import { DialogOrderComponent } from './dialog-order/dialog-order.component';
import { DialogPaymentListComponent } from './dialog-payment-list/dialog-payment-list.component';
import { DialogPaymentComponent } from './dialog-payment/dialog-payment.component';
import { DialogProductComponent } from './dialog-product/dialog-product.component';
import { DialogSearchUserComponent } from './dialog-search-user/dialog-search-user.component';
import { DialogStockComponent } from './dialog-stock/dialog-stock.component';
import { DialogTransportComponent } from './dialog-transport/dialog-transport.component';
import { DialogUserLatestCampaignsReportComponent } from './dialog-user-latestcampaigns-report/dialog-user-latestcampaigns-report.component';
import { DialogUserLevelChangesComponent } from './dialog-user-level-changes/dialog-user-level-changes.component';
import { DialogUserInactiveComponent } from './dialog-user-inactive/dialog-user-inactive.component';
import { InfoComponent } from './info/info.component';
import { ViewOrderComponent } from './view-order/view-order.component';
import { DialogNotifyResellerComponent } from './dialog-notify-reseller/dialog-notify-reseller.component';
import { DialogUserGeoZoneComponent } from './dialog-user-geozone/dialog-user-geozone.component';
import { DialogBuyIntentionGeoZoneComponent } from './dialog-buy-intention-geozone/dialog-buy-intention-geozone.component';
import { DialogNewActionPointCategoryComponent } from './club-gigot/dialog-new-action-point-category/dialog-new-action-point-category.component';
import { ConfirmPointsComponent } from './confirm-points/confirm-points.component';
import {SmallProductCardComponent} from "./small-product-card/small-product-card.component";
import { DialogCategoryProductComponent } from './club-gigot/dialog-category-product-cg/dialog-category-product-cg.component';
import { DialogInventoryProductComponent } from './club-gigot/dialog-inventory-product/dialog-inventory-product.component';
import {
    DialogAddNewCatalogProductComponent
} from "./club-gigot/dialog-add-new-catalog-product/dialog-add-new-catalog-product.component";
import {
    DialogCatalogCampaignProductComponent
} from "./club-gigot/dialog-catalog-campaign-product/dialog-catalog-campaign-product.component";
import { DialogPointsExpirationConfigurationComponent } from './club-gigot/dialog-points-expiration-configuration/dialog-points-expiration-configuration.component';
import { DialogAdvancedSaleChoiceComponent } from './club-gigot/dialog-advanced-sale-choice/dialog-advanced-sale-choice.component';
import { DialogAddProductGroupComponent } from './club-gigot/dialog-add-product-group/dialog-add-product-group.component';
import { DialogAdvanceSaleComponent } from './club-gigot/dialog-advance-sale/dialog-advance-sale.component';
import { DialogAdvancedSaleRequiredProductGroupComponent } from './club-gigot/dialog-advanced-sale-required-product-group/dialog-advanced-sale-required-product-group.component';
import { DialogAddAdvanceSaleLevelComponent } from './club-gigot/dialog-add-advance-sale-level/dialog-add-advance-sale-level.component';
import { DialogExtraPointsComponent } from './club-gigot/dialog-extra-points/dialog-extra-points.component';
import { AddOrderEventBasketMaterialModalComponent } from '../pages/order-events-returns-reports-edit/new-material-modal/new-material-for-order-event-basket.component';


@NgModule({
  declarations: [
    DialogStockComponent,
    DialogConfigDebtComponent,
    DialogConfigBrochureComponent,
    DialogAnnulment,
    DialogOrderEventComponent,
    DialogOrderComponent,
    DialogPaymentComponent,
    DialogPaymentListComponent,
    DialogCampaignComponent,
    AuthNoticeComponent,
    DialogCommercialStructureComponent,
    ConfirmComponent,
    ConfirmPointsComponent,
    DialogOrderBillingComponent,
    AlertComponent,
    InfoComponent,
    BarcodeComponent,
    DialogSearchUserComponent,
    DialogCampaignProductComponent,
    DialogProductComponent,
    DialogMessageComponent,
    DialogTransportComponent,
    DialogConfigLogisticComponent,
    DialogConfigBrandingComponent,
    ViewOrderComponent,
    DialogCreditNotesComponent,
    CampaignSelectorComponent,
    DialogDebtReportComponent,
    DialogUserLatestCampaignsReportComponent,
    DialogUserLevelChangesComponent,
    DialogUserGeoZoneComponent,
    DialogBuyIntentionGeoZoneComponent,
    DialogUserInactiveComponent,
    DialogNotifyResellerComponent,
    DialogCopyActionPointComponent,
    DialogNewActionPointCategoryComponent,
    SmallProductCardComponent,
    DialogCategoryProductComponent,
    DialogInventoryProductComponent,
    DialogAddNewCatalogProductComponent,
    DialogCatalogCampaignProductComponent,
    DialogPointsExpirationConfigurationComponent,
    DialogAdvancedSaleChoiceComponent,
    DialogAddProductGroupComponent,
    DialogAdvanceSaleComponent,
    DialogAdvancedSaleRequiredProductGroupComponent,
    DialogAddAdvanceSaleLevelComponent,
    DialogExtraPointsComponent,
    AddOrderEventBasketMaterialModalComponent
  ],
  imports: [
    CommonModule,
    PartialsModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    DragDropModule,
    MatDatepickerModule,
    MatSelectModule,
    MatSnackBarModule,
    MatPaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    NgbModule,
    MatCheckboxModule,
    NgxDropzoneModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatDialogModule,
    MatRadioModule,
    MatDividerModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatBadgeModule,
    DirectiveModule,
    PipeModule,
    ComponentModule,
    NgxBarcodeModule,
    MatSlideToggleModule,
    MatChipsModule
  ],
  exports: [
    DialogStockComponent,
    DialogConfigDebtComponent,
    DialogConfigBrochureComponent,
    DialogAnnulment,
    DialogOrderEventComponent,
    DialogOrderComponent,
    DialogPaymentComponent,
    DialogPaymentListComponent,
    DialogCampaignComponent,
    DialogCommercialStructureComponent,
    ConfirmComponent,
    ConfirmPointsComponent,
    DialogOrderBillingComponent,
    AlertComponent,
    InfoComponent,
    BarcodeComponent,
    DialogSearchUserComponent,
    DialogCampaignProductComponent,
    DialogProductComponent,
    DialogMessageComponent,
    DialogTransportComponent,
    DialogConfigLogisticComponent,
    DialogConfigBrandingComponent,
    DialogCreditNotesComponent,
    CampaignSelectorComponent,
    DialogDebtReportComponent,
    DialogUserLevelChangesComponent,
    DialogUserGeoZoneComponent,
    DialogBuyIntentionGeoZoneComponent,
    DialogUserLatestCampaignsReportComponent,
    DialogUserInactiveComponent,
    DialogNotifyResellerComponent,
    DialogCopyActionPointComponent,
    DialogNewActionPointCategoryComponent,
    SmallProductCardComponent,
    DialogCategoryProductComponent,
    DialogInventoryProductComponent,
    DialogAddNewCatalogProductComponent,
    DialogCatalogCampaignProductComponent,
    DialogPointsExpirationConfigurationComponent,
    DialogAdvancedSaleChoiceComponent,
    DialogAddProductGroupComponent,
    DialogAdvancedSaleRequiredProductGroupComponent,
    DialogAddAdvanceSaleLevelComponent,
    DialogExtraPointsComponent,
    AddOrderEventBasketMaterialModalComponent
  ],
  entryComponents: [
    DialogStockComponent,
    DialogConfigDebtComponent,
    DialogConfigBrochureComponent,
    DialogAnnulment,
    DialogOrderEventComponent,
    DialogOrderComponent,
    DialogPaymentComponent,
    DialogPaymentListComponent,
    DialogCampaignComponent,
    DialogCommercialStructureComponent,
    ConfirmComponent,
    ConfirmPointsComponent,
    DialogOrderBillingComponent,
    AlertComponent,
    InfoComponent,
    BarcodeComponent,
    DialogSearchUserComponent,
    DialogCampaignProductComponent,
    DialogProductComponent,
    DialogMessageComponent,
    DialogTransportComponent,
    DialogConfigLogisticComponent,
    DialogConfigBrandingComponent,
    DialogCreditNotesComponent,
    DialogDebtReportComponent,
    DialogUserLevelChangesComponent,
    DialogUserGeoZoneComponent,
    DialogBuyIntentionGeoZoneComponent,
    DialogUserLatestCampaignsReportComponent,
    DialogUserInactiveComponent,
    DialogNotifyResellerComponent,
    DialogCopyActionPointComponent,
    DialogNewActionPointCategoryComponent,
    SmallProductCardComponent,
    DialogCategoryProductComponent,
    DialogInventoryProductComponent,
    DialogAddNewCatalogProductComponent,
    DialogCatalogCampaignProductComponent,
    DialogPointsExpirationConfigurationComponent,
    DialogAdvancedSaleChoiceComponent,
    DialogAddProductGroupComponent,
    DialogAdvanceSaleComponent,
    DialogAdvancedSaleRequiredProductGroupComponent,
    DialogAddAdvanceSaleLevelComponent,
    DialogExtraPointsComponent,
    AddOrderEventBasketMaterialModalComponent
  ]
})
export class SharedModule { }
